import http from '@/utils/api2'

const doSave = async (bomList) => {
  const res = await http.post(`/erp/bom/save`, bomList)
  return res
}

export default {
  doSave
}
